import React from "react";
import RecipientsPanelView from "./view";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { globalStyles, noop } from "@client/shared/constants";
import DeleteIcon from "@mui/icons-material/Delete";
import style from "./style";

const RecipientsPanel = ({
  isAllRecipients = false,
  siteList = [],
  departmentList = [],
  userRoleList = [],
  individualContactList = [],
  recipientSites = [],
  recipientDepartments = [],
  recipientRoles = [],
  recipientSelectedContacts = [],
  recipients = [],
  notifyRecipient = false,
  roleAccess = {},
  handleChange = noop,
  removeRecipient = noop,
  updateRecipientList
}) => {
  const columnConfig = [
    {
      id: "name",
      field: "name",
      label: "NAME",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row.name || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row.name || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "site",
      field: "site",
      label: "SITE",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row.site || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row.site || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "department",
      field: "department",
      label: "DEPARTMENT",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row.department || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row.department || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "role",
      field: "role",
      label: "ROLE",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row.role || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row.role || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "col-action",
      label: "",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Box
          sx={{
            ...globalStyles.display.flex,
            ...globalStyles.flex.end,
          }}
        >
          <DeleteIcon
            onClick={() => {
              removeRecipient(row.id);
            }}
            sx={{
              ...globalStyles.cursor.pointer,
            }}
          />
        </Box>
      ),
    },
  ];

  return (
    <RecipientsPanelView
      isAllRecipients={isAllRecipients}
      siteList={siteList}
      departmentList={departmentList}
      userRoleList={userRoleList.filter(role => !role.hidden)}
      individualContactList={individualContactList}
      recipientSites={recipientSites}
      recipientDepartments={recipientDepartments}
      recipientRoles={recipientRoles}
      recipientSelectedContacts={recipientSelectedContacts}
      recipients={recipients}
      columnConfig={columnConfig}
      notifyRecipient={notifyRecipient}
      roleAccess={roleAccess}
      handleChange={handleChange}
      updateRecipientList={updateRecipientList}
    />
  );
};

export default RecipientsPanel;
